import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types'; 
import {
    Chapter,
    Career01,
  } from "../imagepath";
function ListKat(props) {
    return (
        <div>
             {/* Instructor List */}
             <div className="col-lg-12 d-flex">
                  <div className="instructor-list flex-fill">
                    <div className="instructor-img">
                      <Link >
                        <img className="img-fluid" alt="" src={require(`../../assets/img/user/${props.image}.png`)} />
                      </Link>
                    </div>
                    <div className="instructor-content">
                      <h5>
                        <Link to={`/sub-kategory/${props.id}`}>{props.title}</Link>
                      </h5>
                      <h6>Produk {props.komoditi}</h6>
                      <div className="instructor-info">
                        <div className="rating-img d-flex align-items-center">
                          <img src={Chapter} className="me-1" alt="" />
                          <p>{props.subkat} Jenis Pangan</p>
                        </div>
                        <div className="course-view d-flex align-items-center ms-0">
                          <img src={Career01} style={{width:'20px'}} className="me-1" alt="" />
                          <p>{props.parameter} Parameter</p>
                        </div>
                      </div>
                      <div className="instructor-badge">
                        <span className="web-badge">Pengujian Kimia</span>&nbsp;
                        <span className="web-badge">Pengujian Mikrobiologi</span>&nbsp;
                      </div>
                    </div>
                  </div>
                </div>
                {/* Instructor List */}
        </div>
    );
}
ListKat.propTypes = {
    title: PropTypes.string.isRequired, // Define title as required string
    komoditi: PropTypes.string.isRequired, // Define title as required string
    id: PropTypes.number.isRequired, // Define title as required string
    subkat: PropTypes.number.isRequired, // Define title as required string
    parameter: PropTypes.number.isRequired, // Define title as required string
    image: PropTypes.string.isRequired, // Define title as required string
};
export default ListKat;